import {defineStore} from 'pinia'
import {ref, reactive, computed, nextTick} from "vue"
import router from "@/router";
import {ROUTE_NAMES} from "@/router"
import Supabase from "@/utils/Supabase";

const usePluStore = defineStore('pluStore', () => {

    const pluItems = ref([])
    const pluItemsBo = computed(() => [...pluItems.value].filter(item => item.place === 'BO'))
    const pluItemsPE = computed(() => [...pluItems.value].filter(item => item.place === 'PE'))
    const loadingPluItems = ref(false)

    const loadPluItems = async () => {
        loadingPluItems.value = true
        const {
            data,
            error
        } = await Supabase.from('v2_Hajcer_PluItems').select('*')
        loadingPluItems.value = false
        if (error) {
            alert('Error loading plu items')
            return
        }
        pluItems.value = data.map(item => ({
            title: item.pluName + ' - ' + item.pluCategoryName + ' - ' + item.pluPrice + ' ' + item.restaurantPlace,
            // title: item.pluName + ' - ' + item.pluCategoryName + ' - ' + item.pluPrice,
            // title: item.id + ' ' + item.pluName + ' - ' + item.pluCategoryName + ' - ' + item.pluPrice + ' ' + item.restaurantPlace,
            value: item.id,
            place: item.restaurantPlace,
            pluId: item.pluId,
            pluCode: item.pluCode,
            pluName: item.pluName,
            pluPrice: item.pluPrice,
        }))
    }

    return {
        pluItemsBo,
        pluItemsPE,
        pluItems,
        loadPluItems,
        loadingPluItems
    }


})

export default usePluStore